import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'deliveryTimeClose',
  initialState: null as null | string,
  reducers: {
    setDeliveryTimeClose(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setDeliveryTimeClose } = slice.actions;

export default slice.reducer;
